import { createContext } from "react";

export const ActiveTabContext = createContext("");
